import React from "react";
import Lottie from "react-lottie-player";
import diveLoader from "@/assets/lottie/diveLoader.json";
import orbitLoader from "@/assets/lottie/orbitLoader.json";
import { cn } from "@/lib/utils/cn";

type Props = {
  /**
   * Optional text to display below the loader
   */
  text?: string;

  /**
   * Optional size of the loader
   */
  size?: "small" | "medium" | "large";

  /**
   * Optional position of the loader
   */
  position?: "top" | "center" | "page-center" | "bottom";

  /**
   * Type of loader to display
   */
  loaderType?: "dive" | "orbit";

  /**
   * Container class name
   */
  containerClassName?: string;
};

/**
 * Display a loader with optional text. The loader is centered by default
 * inside the containing div.
 */
export const Loader = ({
  text,
  size,
  position,
  loaderType = "orbit",
  containerClassName,
}: Props) => {
  let sizeClass = "h-20 w-20";
  switch (size) {
    case "small":
      sizeClass = "h-10 w-10";
      break;
    case "large":
      sizeClass = "h-40 w-40";
      break;
  }

  let positionClass = "justify-center";
  switch (position) {
    case "top":
      positionClass = "items-start w-full";
      break;
    case "center":
      positionClass = "items-center w-full mb-16 justify-center";
      break;
    case "bottom":
      positionClass = "items-end w-full";
      break;
    case "page-center":
      positionClass = "items-center justify-center w-screen h-[80dvh]";
      break;
  }

  const loader = loaderType === "dive" ? diveLoader : orbitLoader;

  return (
    <div className={cn("flex acq-loader", positionClass, containerClassName)}>
      <div className="flex flex-col justify-center">
        <Lottie
          loop
          animationData={loader}
          play
          className={cn(sizeClass, "mx-auto")}
        />
        {text && <p className="text-center text-gray-500">{text}</p>}
      </div>
    </div>
  );
};
